(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart_currency-checkpoint-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'currency-checkpoint-bar[data-currency-checkpoint]';

    const replaceToken = (value, token, replacement) => value.split(token).join(replacement);

    const formatCurrency = (cents, currency, locale) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      } catch {
        return `${currency} ${(cents / 100).toFixed(2)}`;
      }
    };

    const getGiftHandles = () => {
      const handles = new Set();
      document.querySelectorAll('cart-drawer-gift[data-handle]').forEach((gift) => {
        if (gift.dataset.handle) handles.add(gift.dataset.handle);
      });
      document.querySelectorAll('currency-free-gift[data-gift-handle]').forEach((gift) => {
        if (gift.dataset.giftHandle) handles.add(gift.dataset.giftHandle);
      });
      return handles;
    };

    const getQualifyingCart = (element) => {
      const giftHandles = getGiftHandles();
      return Array.from(element.querySelectorAll('[data-currency-checkpoint-line]')).reduce((cart, line) => {
        const excluded = line.dataset.cartHidden === 'true' || giftHandles.has(line.dataset.productHandle);
        if (excluded) return cart;
        cart.total += Number(line.dataset.lineTotal) || 0;
        cart.quantity += Number(line.dataset.quantity) || 0;
        return cart;
      }, { total: 0, quantity: 0 });
    };

    const update = (element) => {
      const isQuantity = element.dataset.goalType === 'quantity';
      const currencyState = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
      const currency = currencyState.active || element.dataset.currency;
      const shopCurrency = element.dataset.shopCurrency;
      const currencyRate = Number(currencyState.rate);
      const rate = currency === shopCurrency ? 1 : (currencyRate > 0 ? currencyRate : null);
      const locale = document.documentElement.lang || 'en';
      const qualifyingCart = getQualifyingCart(element);
      const reference = isQuantity ? qualifyingCart.quantity : qualifyingCart.total;
      const infuserShippingUnlocked = element.dataset.infuserShippingUnlocked === 'true'
        && element.dataset.hasSubscription !== 'true';
      const shippingGoalIndex = Number(element.dataset.shippingGoalIndex);

      if (!Number.isFinite(reference)) return;
      if (!isQuantity && (!currency || !rate)) return;

      const goals = [1, 2, 3]
        .filter((index) => element.getAttribute(`data-enable-goal-${index}`) === 'true')
        .map((index) => {
          const amount = Number(element.getAttribute(`data-goal-${index}-amount`));
          return {
            index,
            unlockedByInfuser: infuserShippingUnlocked && index === shippingGoalIndex,
            amount,
            target: isQuantity ? amount : Math.round(amount * 100 * rate),
            text: element.getAttribute(`data-goal-${index}-text`) || ''
          };
        })
        .filter((goal) => Number.isFinite(goal.amount) && goal.amount > 0);

      if (goals.length === 0) return;

      const highestGoal = goals[goals.length - 1].target;
      const progressReference = goals.length === 1 && goals[0].unlockedByInfuser ? highestGoal : reference;
      const progress = Math.min(100, Math.max(0, (progressReference / highestGoal) * 100));
      const progressBar = element.querySelector('.cart-progress__bar__progress');

      if (progressBar) {
        progressBar.style.width = `${progress}%`;
      }

      const badges = element.querySelectorAll('.cart-progress__bar__badge');
      goals.forEach((goal, index) => {
        if (badges[index]) {
          badges[index].style.setProperty('--position', `${(goal.target / highestGoal) * 100}%`);
          badges[index].toggleAttribute('data-goal-reached', goal.unlockedByInfuser || reference >= goal.target);
          badges[index].setAttribute('data-infuser-shipping-reached', String(goal.unlockedByInfuser));
        }
      });

      const message = element.querySelector('.cart-progress__text');
      if (!message) return;

      const nextGoal = goals.find((goal) => !goal.unlockedByInfuser && goal.target > reference);
      if (!nextGoal) {
        message.textContent = element.dataset.successMessage || '';
        return;
      }

      const amount = isQuantity
        ? String(Math.max(0, Math.ceil(nextGoal.target - reference)))
        : formatCurrency(nextGoal.target - reference, currency, locale);
      let output = element.dataset.progressMessage || '';
      output = replaceToken(output, '[amount]', amount);
      output = replaceToken(output, '[next_goal]', nextGoal.text);
      output = replaceToken(output, '[next_goal_lowercase]', nextGoal.text.toLocaleLowerCase(locale));
      const shippingGoal = goals.find((goal) => goal.unlockedByInfuser);
      message.textContent = shippingGoal ? `${shippingGoal.text} ✓ · ${output}` : output;
    };

    const updateWithin = (root) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches && root.matches(selector)) update(root);
      root.querySelectorAll(selector).forEach(update);
    };

    const start = () => {
      updateWithin(document);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) updateWithin(node);
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', (event) => updateWithin(event.target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart_currency-free-gift"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'currency-free-gift[data-currency-free-gift]';

    const formatCurrency = (cents, currency, locale) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      } catch {
        return currency + ' ' + (cents / 100).toFixed(2);
      }
    };

    const getRate = (element) => {
      const currencyState = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
      const currency = currencyState.active || element.dataset.currency;
      const shopCurrency = element.dataset.shopCurrency;
      const currencyRate = Number(currencyState.rate);
      const rate = currency === shopCurrency ? 1 : (currencyRate > 0 ? currencyRate : null);
      return { currency, rate };
    };

    const update = (element) => {
      const template = element.querySelector('template[data-currency-free-gift-template]');
      const output = element.querySelector('[data-currency-free-gift-output]');
      if (!template || !output) return;

      const isQuantity = element.dataset.goalType === 'quantity';
      const cartTotal = Number(element.dataset.cartTotal);
      const itemsCount = Number(element.dataset.itemsCount);
      const requirementValue = Number(element.dataset.requirement);
      const displayAmount = Number(element.dataset.displaySubtotalAmount);
      const displayType = element.dataset.display;
      const currencyData = getRate(element);
      const needsRate = !isQuantity || displayType === 'subtotal_less_than' || displayType === 'subtotal_more_than';

      if (!Number.isFinite(cartTotal) || !Number.isFinite(itemsCount) || !Number.isFinite(requirementValue)) return;
      if (needsRate && !currencyData.rate) return;

      if (displayType === 'subtotal_less_than' || displayType === 'subtotal_more_than') {
        if (!Number.isFinite(displayAmount)) return;
        const displayThreshold = Math.round(displayAmount * 100 * currencyData.rate);
        const shouldDisplay = displayType === 'subtotal_less_than'
          ? cartTotal < displayThreshold
          : cartTotal > displayThreshold;
        if (!shouldDisplay) {
          output.replaceChildren();
          return;
        }
      }

      const requirement = isQuantity
        ? requirementValue
        : Math.round(requirementValue * 100 * currencyData.rate);
      const reference = isQuantity ? itemsCount : cartTotal;
      const unlocked = reference >= requirement;
      const fragment = template.content.cloneNode(true);
      const gift = fragment.querySelector('cart-drawer-gift');

      if (!gift) {
        output.replaceChildren(fragment);
        return;
      }

      gift.setAttribute('data-selected', String(unlocked));
      gift.setAttribute('data-requirement', String(requirement));

      const message = fragment.querySelector('.cart-drawer-gift__progress');
      if (message) {
        const templateText = unlocked ? element.dataset.unlockedText : element.dataset.lockedText;
        if (isQuantity) {
          message.textContent = (templateText || '').split('[amount]').join(String(Math.max(0, Math.round(requirement - itemsCount))));
        } else {
          const remaining = formatCurrency(Math.max(0, requirement - cartTotal), currencyData.currency, document.documentElement.lang || 'en');
          message.textContent = (templateText || '').split('[amount]').join(remaining);
        }
      }

      const image = fragment.querySelector('.upsell__image');
      const overlay = fragment.querySelector('.cart-drawer-gift__image__locked');
      if (unlocked && overlay) {
        overlay.remove();
      } else if (!unlocked && element.dataset.showLockedOverlay === 'true' && image && !overlay) {
        const lockedOverlay = document.createElement('div');
        lockedOverlay.className = 'cart-drawer-gift__image__locked';
        const lock = document.createElement('span');
        lock.className = 'lock';
        lockedOverlay.appendChild(lock);
        image.appendChild(lockedOverlay);
      }

      output.replaceChildren(fragment);
    };

    const updateWithin = (root) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches && root.matches(selector)) update(root);
      root.querySelectorAll(selector).forEach(update);
    };

    const start = () => {
      updateWithin(document);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) updateWithin(node);
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', (event) => updateWithin(event.target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
